import { PermissionService } from '@abp/ng.core';
import { AbpOAuthService } from '@abp/ng.oauth';
import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'root',
  templateUrl: './root.component.html',
  styleUrl: './root.component.scss'
})
export class RootComponent implements OnInit {


  constructor(private readonly router: Router, public permissionService: PermissionService,
    private readonly abpoauthService: AbpOAuthService) { }

  ngOnInit(): void {
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        if (e.url == "/" || e.url.startsWith("/?")) {
          if (this.abpoauthService.isAuthenticated) {
            if (localStorage.getItem('route')) {
              if (!localStorage.hasOwnProperty('redirect-url')) {
                if (!this.permissionService.getGrantedPolicy('Lead.PreLead')) {
                  this.router.navigate([localStorage.getItem('route') + '/dashboard']);
                }
              } else {
                this.router.navigate([localStorage.getItem('route') + '/' + localStorage.getItem('redirect-url')]);
              }
            }
          } else {
            this.router.navigate(['nextere'])
          }
        }
      }
    });
  }

}
